import GatewayAccountBillingDetailsService from './services/GatewayAccountBillingDetailsService';
import 'edge/billing/app';

export default angular.module('edge.gateway.billing.app', ['edge.billing.app']).factory('billing.AccountBillingDetailsService', GatewayAccountBillingDetailsService);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/billing/app.js
// module id = 1606
// module chunks = 0